<template>
    <coupon-base :discount="discount">
        <template slot-scope="{ formattedPercentage, formattedAmount, removeCoupon }">
            <div class="md:flex md:-mx-4">
                <div class="w-full mb-2 md:w-1/2 md:mx-4 border rounded shadow-sm">
                    <div class="px-4 py-4">
                        <button
                            class="btn btn-sm btn-danger"
                            style="float: right"
                            @click="removeCoupon(discount.code)"
                        >
                            X
                        </button>
                        <p><b>{{ discount.name }}</b></p>
                        <div>
                            {{ __('Kód: :code', {code: discount.code}) }}
                        </div>
                        <div>
                            {{
                                __('Kedvezmény: :percentage%', {
                                    percentage: formattedPercentage
                                })
                            }}
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </coupon-base>
</template>

<script>
import currencyFormatter from '../../mixins/currencyFormatter';
import {mapState} from 'vuex';

export default {
    name: 'PercentCoupon',
    mixins: [currencyFormatter],
    props: {
        discount: {
            type: Object,
            required: true
        }
    },

    computed: {
        ...mapState('cart', [
            'items'
        ]),
    }
}
</script>
